import React from 'react';
import type { ConnectedProps } from 'react-redux';
import { connect } from 'react-redux';

import type { RootState } from 'reducers/types';
import {
  getSelectedOffer,
  isSelectedOfferLegacyInstallment,
  isSelectedOfferLegacySubscription,
  isSelectedOfferRecurring,
} from 'selectors';
import { useTranslations } from 'utils';

import { Breakdown } from '../Breakdown/Breakdown';
import { LegacyRecurringBreakdown } from './components/LegacyRecurringBreakdown/LegacyRecurringBreakdown';
import { RecurringBreakdown } from './components/RecurringBreakdown/RecurringBreakdown';
import { SubscriptionBreakdown } from './components/SubscriptionBreakdown/SubscriptionBreakdown';

type PaymentOptionsBreakdownProps = ConnectedProps<typeof connector>;

export const PaymentOptionsBreakdownComponent = ({
  offer: { name },
  isLegacyInstallment = false,
  isLegacySubscription = false,
  isRecurring = false,
}: PaymentOptionsBreakdownProps) => {
  const i18n = useTranslations();

  return (
    <Breakdown
      title={i18n.t('paymentOptionsBreakdown.paymentMethod') as string}
      id="paymentMethod"
    >
      <div id="paymentMethod-description">
        <dl>
          <div>
            <dt>{i18n.t('paymentOptionsBreakdown.paymentOption')}</dt>
            <dd data-hj-suppress>{name}</dd>
          </div>
          {isLegacyInstallment && <LegacyRecurringBreakdown />}
          {isLegacySubscription && <SubscriptionBreakdown />}
          {isRecurring && <RecurringBreakdown />}
        </dl>
      </div>
    </Breakdown>
  );
};

const mapStateToProps = (state: RootState) => ({
  isLegacyInstallment: isSelectedOfferLegacyInstallment(state),
  isLegacySubscription: isSelectedOfferLegacySubscription(state),
  isRecurring: isSelectedOfferRecurring(state),
  offer: getSelectedOffer(state),
});

const connector = connect(mapStateToProps);
const PaymentOptionsBreakdown = connector(PaymentOptionsBreakdownComponent);

export { PaymentOptionsBreakdown };
